import React, { useState } from 'react';
import { Button, Divider, Select } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useAuthStore } from '@/store/authStore';
import { useWorkWeeks } from './useWorkWeeks';
import WorkWeekModal from './WorkWeekModal';

type Props = {
  value?: string;
  onChange?: (code: string) => void;
  disabled?: boolean;
};

const MANAGE_PERMISSIONS = ['hr.setup.manage', 'hr.view', 'hr.employee.edit'];

/** Work week dropdown with an "Add work week" entry for patterns not in the list. */
const WorkWeekSelect: React.FC<Props> = ({ value, onChange, disabled }) => {
  const { options, isLoading } = useWorkWeeks();
  const { user } = useAuthStore();
  const canManage =
    Boolean(user?.is_super_admin) || MANAGE_PERMISSIONS.some((p) => user?.permissions?.includes(p));
  const [adding, setAdding] = useState(false);

  return (
    <>
      <Select
        value={value}
        onChange={onChange}
        disabled={disabled}
        loading={isLoading}
        options={options}
        showSearch
        optionFilterProp="label"
        dropdownRender={(menu) =>
          canManage ? (
            <>
              {menu}
              <Divider style={{ margin: '4px 0' }} />
              <Button type="text" block icon={<PlusOutlined />} onClick={() => setAdding(true)}>
                Add work week
              </Button>
            </>
          ) : (
            menu
          )
        }
      />
      <WorkWeekModal
        open={adding}
        startAdding
        onClose={() => setAdding(false)}
        onCreated={(code) => onChange?.(code)}
      />
    </>
  );
};

export default WorkWeekSelect;
